import {FullscreenView} from '@fantasmagames/core/src/screen/fullscreen/FullscreenView';
import {ScreenOrientation} from '@fantasmagames/core/src/screen/fullscreen/FullscreenManager';

export class DefaultFullscreenView implements FullscreenView {

	public handle(orientation: ScreenOrientation): void {
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/screen/fullscreen/DefaultFullscreenView.ts